import React, { useState } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import CheckIcon from "@material-ui/icons/Check";
import { formatGermanPhone } from "./phone";

export default function PhoneCallButton({ number }: { number?: string | null; email?: string | null }) {
  const [copied, setCopied] = useState(false);
  const [copyFailed, setCopyFailed] = useState(false);
  const phone = (number || "").trim();
  if (!phone) return null;
  const display = formatGermanPhone(phone);
  const dialNumber = phone.replace(/^(\+49|0049)\s*\(0\)/, "$1").replace(/[^+\d]/g, "");
  const copyPhone = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    try {
      await navigator.clipboard.writeText(display);
      setCopied(true);
      setCopyFailed(false);
    } catch {
      setCopyFailed(true);
    }
  };
  const copyLabel = copyFailed ? "Kopieren fehlgeschlagen – bitte Nummer markieren" : copied ? "Telefonnummer kopiert" : "Telefonnummer kopieren";
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
      <a href={`tel:${dialNumber}`} aria-label={`${display} anrufen`}
        onClick={(event) => event.stopPropagation()}
        style={{ color: "inherit", textDecoration: "none", fontVariantNumeric: "tabular-nums" }}>
        {display}
      </a>
      <Tooltip title={copyLabel}>
        <IconButton aria-label={copyLabel} size="small" onClick={copyPhone}
          onBlur={() => { setCopied(false); setCopyFailed(false); }} style={{ color: "inherit" }}>
          {copied ? <CheckIcon fontSize="small" /> : <FileCopyOutlinedIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
      <span role="status" style={{ position: "absolute", width: 1, height: 1, padding: 0, overflow: "hidden", clip: "rect(0, 0, 0, 0)" }}>
        {copied ? "Telefonnummer kopiert" : copyFailed ? copyLabel : ""}
      </span>
    </span>
  );
}
